export default __webpack_public_path__ + "static/about2-f67ba7261252067d895d81bc9d345985.webp";